import { Capacitor } from "@capacitor/core";
import { getDeployEnv } from "../../environment.js";

// MEIS-13220: the deploy-compat machinery is inert on local dev and on
// Capacitor native platforms (the mobile app has its own forced OTA flow).
// Shared by the DeployCompatibility provider AND the Apollo errorLink's
// reactive-recovery path — the latter reloads directly, so it must apply
// the same skip or a native webview would be reloaded outside the OTA flow.
export function isDeployCompatInert(): boolean {
  return getDeployEnv() === "local" || Capacitor.isNativePlatform();
}
